export type ResultadoImportacaoLeitor = {
  criados: number;
  atualizados: number;
  comFoto: number;
  semFoto: number;
  ignorados: number;
  avisos?: string[];
};

export function mensagemResultadoImportacaoControlId(resultado: ResultadoImportacaoLeitor) {
  const todosAvisos = resultado.avisos ?? [];
  const avisos = todosAvisos.slice(0, 8);
  const extra = todosAvisos.length > 8 ? `\n+${todosAvisos.length - 8} aviso(s)` : '';
  const detalhe = avisos.length ? `\n${avisos.join('\n')}${extra}` : '';
  return `Importacao no iD Face: ${resultado.criados} criados, ${resultado.atualizados} atualizados, ${resultado.comFoto} com foto, ${resultado.semFoto} sem foto, ${resultado.ignorados} ignorados.${detalhe}`;
}
